import React from 'react';

import Checkbox from '@ott/checkbox';
import { l10n } from '@ott/l10n';

import { dataLocators, fieldsNames } from '../../../constants';
import { useCreditCardContext } from '../../../provider';

import styles from './SaveCardCheckbox.scss';

export const SaveCardCheckbox = () => {
  const { cardToDisplay, changeFieldValue } = useCreditCardContext();

  const handleSaveCardChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    changeFieldValue(fieldsNames.saveCard, e.target.checked);
  };

  return (
    <div className={styles.checkboxWrapper}>
      <Checkbox
        isChecked={Boolean(cardToDisplay.saveCard)}
        onChange={handleSaveCardChange}
        specificLocators={dataLocators.saveCard}
      >
        {l10n('paymentCardNew.saveCardData')}
      </Checkbox>
    </div>
  );
};
